module.exports = __webpack_public_path__ + "img/extension.62d7ed75.png";